<template>
  <div class="content">
    <!-- <el-card class="left-bar" :style="{ height: contentHeight }"> -->
    <el-card class="left-bar" style="width: 320px;" :style="{ height: '720px', }">
      <div style="display:flex">
        <el-input size="small" class="search-input" v-model="searchValue" suffix-icon="el-icon-search"></el-input>
      </div>
      <div class="left-list">
        <li v-for="item in dataList" :key="item.id" class="list" :class="{ active: item.active }">
          <div class="list-title" :title="item.name" @click="getSub(item)">{{ item.name }}</div>
          <!-- <span style="cursor: pointer; height: 24px;line-height: 24px;" class="el-icon-delete" @click="deleteItem(item)"> </span> -->
        </li>
      </div>
    </el-card>
    <el-card class="right-content" :style="{ height: '720px' }" v-loading="loading">

      <div class="title">
        <div v-if="showWarnning" class="warnning"> <i class="el-icon-warning"></i>{{ $t('message.tips.createNewData')
        }} </div>
        <div class="des-item" v-for="(item, index) in desList" :key="item.index">
          <div class="des-label"> {{ item.name + ': ' }} </div>
          <div class="des-options">
            <div v-if="item.uiType == 3 || item.uiType == 4">
              <div style="display:flex; ">
                <div class="listEntries" ref="listEntries">
                  <span class="item" v-for="tag in item.listEntries" :key="tag.value">
                    <el-tag effect="dark" :type="!tag.type ? 'info' : 'primary'" size="small"
                      style="margin :0 0 3px 3px;cursor: pointer;" @click="getPoint(tag, index)">{{ tag.label }}
                    </el-tag>
                  </span>
                </div>
                <div class="expend" @click='getExpend(item, index)'>
                  <i class="el-icon-arrow-down icon-pro" :class="{ isActive: item.expend }"></i>
                  <span>{{ !item.expend ? $t('message.button.expand') : $t('message.button.close') }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <el-input v-model="item.value" size="small" @keyup.enter.native="search()" @blur="search()"></el-input>
            </div>
          </div>
        </div>

      </div>


      <div class="table">
        <vxe-toolbar ref="xToolbar" custom print export>
          <template #buttons>
            <span> {{ $t("message.title.totalResults") + totalLength + $t("message.title.resultsNums") }}
            </span>
          </template>
        </vxe-toolbar>

        <div>
          <vxe-table border height="500" show-overflow align="center" class="mytable-style" @cell-dblclick="cellClick"
            :cell-class-name="cellClassName" resizable ref="table" :print-config="{}" :toolbar-config="tableToolbar"
            :row-style="rowStyle" :data="gridOptions.data">
            <!-- <vxe-column v-for="item in TagList" :title="item.title" :field="item.field" :key="item.title" minWidth="36">
              <template slot="header" slot-scope="scope">
                <i :class="item.icon" :title="item.title"></i>
              </template>
              <template slot-scope="scope">
                <i :class="item.icon" :title="item.field" v-show="Number(scope.row[item.field])"></i>
              </template>
            </vxe-column> -->
            <vxe-column v-for="item in columnList" :title="item.title" :field="item.field" :key="item.index"
              :minWidth="item.minWidth">
            </vxe-column>
            <template #empty>
              <my-empty />
            </template>
          </vxe-table>
        </div>
      </div>
    </el-card>

  </div>
</template>
<script>

import axios from "axios";
import MyEmpty from "@/views/components/empty.vue";
export default {
  name: "componentLibrary",
  data() {
    return {

      columnList: [],

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,

      seekId: 0,

      searchValue: '',

      desList: [],
      list: [],

      loading: false,

      colorList: ["#13ce66", "#fcad2c", "#F56C6C", "#38A8F6"],
      iconType: [],

      TagList: [],
      abcList: [],

      tableToolbar: {
        buttons: [{ code: "myInsert", name: "aaaaaaaaaaaaa", type: "text" }],
        print: true,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },
      isPro: false,
      rowStyle: { cursor: "pointer" },
      gridOptions: {
        id: '',
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 660,
        align: "left",
        highlightHoverRow: true,
        editConfig: { trigger: "dblclick", mode: "row" },
        columns: [],
        data: [],
        customConfig: { storage: true }
      },

      baseData: []
    };
  },
  components: {
    // SearchQuery,
    // TitleTag,
    MyEmpty
  },
  computed: {
    // contentHeight: function () {
    //   return this.$store.state.elementHight-40 + "px"; //自定义高度需求
    // },
    showWarnning() {
      return !this.baseData.length
    },
    dataList() {
      return this.list.filter(i => i.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) != -1);
    },
    showContent() {
      return this.list.some(i => i.active);
    },

    totalLength() {
      return this.gridOptions.data.length
    }

  },
  mounted() {
    // this.$store.commit('setIncludesList', 'componentLibrary');

  },
  created() {
    this.getList();
    // this.getData();
  },
  methods: {
    // handleSizeChange(val) {
    //   this.pageSize = val
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;

    // },
    cellClick({ row, column }) {
      console.log(row);
      const obj = {
        ...row.objInfo,
        title: row['1000001']
      }
      this.getLink(obj);
      // if (column.property == this.linkProperty) {
      // this.rowClick(row);
      // }
    },
    getSub(e) {
      console.log(e);
      this.dataList.map(i => i.active = false)
      e.active = true;
      this.desList = [];
      this.baseData = [];
      this.columnList = [];
      this.TagList = [];
      this.abcList = [];
      this.gridOptions.data = [];
      this.loading = true;
      this.getData(e);
    },

    getPoint(item, index) {
      item.type = !item.type;
      this.desList[index].value = this.desList[index].listEntries.filter(i => i.type).map(i => i.value);
      this.search();
    },
    getExpend(item, e) {
      console.log(item, e);
      item.expend = !item.expend;
      if (item.listEntries.length < 12) {
        return;
      }
      const arr = this.desList.filter(i => i.uiType == 3 || i.uiType == 4);
      const el = arr.findIndex(i => item.id == i.id);
      if (item.expend) {
        this.$refs.listEntries[el].classList = this.$refs.listEntries[el].classList + ' list-expend'
      } else {
        this.$refs.listEntries[el].classList = this.$refs.listEntries[el].classList[0]
      }

    },
    search() {
      //  console.log(this.desList);
      // const arr = this.desList.filter(i => i.value.length);
      function hasRepeat(a, b) {
        let c = [...a, ...b];
        const d = [...new Set([...c])];
        return d.length < c.length
      }
      let list = [];
      this.desList.filter(i => i.value.length).map((i, index) => {
        // console.log(this.columnList);
        const e = this.columnList.findIndex(j => j.field == i.id);
        console.log(e, i.id, this.columnList);
        let arr = !index ? this.baseData : [...list];
        console.log(arr, this.baseData);
        // console.log(arr);
        list = arr.filter(j => {
          if (i.uiType == 3 || i.uiType == 4) {
            // console.log(i, j.cells[e]);
            if (!j.cells.length) {
              return false
            } else {
              // console.log(j.cells[e]);
              const cell = !j.cells[e].ids ? j.cells[e].id.toString().split(';') : j.cells[e].ids.split(';');
              return hasRepeat(cell, i.value);
            }
          }
          else {
            return j.cells[e].val.indexOf(i.value) != -1
          }
        });
      })

      console.log(list);

      this.gridOptions.data = list.map(i => {
        let obj = {};
        for (let index = 0; index < this.columnList.length; index++) {
          const element = this.columnList[index].field;
          obj[element] = i.cells[index].val
        }
        obj.objInfo = i.objInfo
        return obj;
      });
    },

    cellClassName({ row, rowIndex, column, columnIndex }) {
      // if (columnIndex == 4) {
      //   return "link_";
      // }
    },

    getData(m) {
      const obj = {
        "seekVo": {
          "baseId": 101,
          "clsId": m.classId,
          "subId": m.subclassId
        },
        "criteriaVos": [],
        "pageSize": 500,
        "currentPage": 1
      }
      axios.post('/search/advanced/search', obj).then(res => {
        // const iconList = [
        //   "el-icon-news",
        //   "el-icon-data-line",
        //   "el-icon-office-building",
        //   "el-icon-paperclip",
        // ];
        // this.baseData = res.data.object['tableP1']?.rows || []
        const arr = res.data.object['tableP1']?.rows || []
        if (!arr.length) {
          this.loading = false
          return;
        }
        this.columnList = [];
        this.baseData = new Array(arr.length).fill('_').map(i => ({ cells: [], objInfo: {} }))
        // res.data.object['tableP1'].columnInfo.names.map((i, e) => (
        //   {
        //     title: i,
        //     field: i,
        //     icon: iconList[e]
        //   })
        // );

        // const arr = ['tableP1','tableP2','tableP3'];
        const pageList = ['pageOne', 'pageTwo', 'pageThree'];
        ['tableP1', 'tableP2', 'tableP3'].filter(i => res.data.object[i]).map((i, e) => {
          const item = res.data.object[i].columnInfo
          const list = m[pageList[e]] || [];
          let rows = res.data.object[i].rows;

          if (!rows.length) {
            rows = new Array(res.data.object['tableP1'].rows.length).fill({ cells: [] })
          }

          const columns = item.ids.map((j, index) => ({
            title: item.names[index],
            field: j + '',
            minWidth: "140",
            sortable: true,
          }))

          console.log(rows);
          this.columnList = this.columnList.concat(columns);
          this.baseData.map((j, index) => {

            const { cells, objId: id, objClass: classId, objSubClass: subClassId } = rows[index];

            j.cells = [...j.cells, ...cells];
            // j.objInfo = { ...j.objInfo, id, classId, subClassId:rows[index].objSubClass }
            if (!e) {
              j.objInfo = { id, classId, subClassId }
            }
          });
          console.log(this.baseData);

          item.ids.map((j, index) => {
            if (list.includes(j)) {
              let obj = {
                id: j,
                name: item.names[index],
                expend: false,
                uiType: item.uiTypes[index],
                value: [3, 4].includes(item.uiTypes[index]) ? [] : ''
              }
              // console.log(item.listIds[index]);
              if (item.listIds[index] != -1) {
                obj.listEntries = Object.entries(item.listEntries[item.listIds[index]]).map(i => ({ value: i[0], label: i[1], type: false }))
              }
              this.desList.push(obj);
            }
          });
        });

        console.log(this.columnList);

        // this.columnList.map((i, e) => {
        //   if (e < 4) {
        //     this.TagList.push(i)
        //   } else (
        //     this.abcList.push(i)
        //   )
        // })
        // console.log(this.abcList);
        this.loading = false;
      })
    },

    getList() {
      axios.get('/pmdm/importTemplate/selectByUsedType?usedType=' + 2).then(res => {
        console.log(res);
        this.list = res.data.object.map((i, e) => {
          i.index = e;
          i.active = false;
          return i;
        });
      })
    },
  },
};
</script>

<style scoped>
.content {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  background: #fff;
  padding-top: 10px;
}

.left-bar {
  width: 280px;

  /* width: 200px; */
  flex-basis: 280px;
  flex-shrink: 0;
  /* border: 1px solid salmon; */
  margin-left: 15px;
  padding: 5px 10px;
  margin-bottom: 15px;

}

.search-input {
  display: inline-block;
}

.search-button {
  margin-left: 5px;
}

.left-list {
  /* padding-right: 15px; */
  height: 620px;
  overflow: auto;
  margin-top: 15px;
}

.active {
  background: #409EFF;
  color: #fff;
  border-radius: 3px;
}

.left-list li {
  line-height: 24px;
  height: 24px;
  padding: 5px 10px;
  font-size: 14px;
  margin: 5px 0;
}

.list {
  display: flex;
}

.list-title {
  cursor: pointer;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-list li:hover {
  /* cursor: pointer; */
  background: #409EFF;
  color: #fff;
  border-radius: 3px;
  transition-delay: 50ms;
}

.right-content {
  flex-grow: 1;
  margin: 0 15px;
  margin-bottom: 15px;
  /* border-left: 1px solid salmon; */
  padding: 5px 15px;
  height: 600px;
  font-size: 16px;

  overflow: scroll;

  display: flex;
  flex-direction: column;
}

.title {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
}

.table {
  flex-grow: 1;
}

.des-item {
  margin-right: 15px;
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  min-width: 46%;

}

.des-label {
  text-align: justify;
  padding: 4px;
  flex-shrink: 0;
}

.des-options {
  max-height: 120px;
  /* flex:1; */
  overflow: hidden;
  /* display: flex; */
  /* overflow: scroll; */
}

.listEntries {
  flex: 1;
  width: 100%;
  height: 27px;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-property: height;
}

.expend {
  width: 80px;
  flex-shrink: 0;
  cursor: pointer;
  padding: 4px;
  color: #409EFF;
}

.list-expend {
  /* height: auto; */
  height: 81px;
  overflow-y: scroll;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-property: height;
}

.warnning {
  font-size: 14px;
}

.icon-pro {
  transition: -webkit-transform .3s;
  -webkit-transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  transition: transform .3s, -webkit-transform .3s;
}

.icon-pro.isActive {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 6px;
  height: 9px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/
.listEntries::-webkit-scrollbar-track {
  width: 6px;
  background-color: #e9e9eb;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条的设置*/
.listEntries::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: #aaaaaa;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条移上去的背景*/
.listEntries::-webkit-scrollbar-thumb:hover {
  background-color: #fff;
}
</style>
